import { Axios } from '../axiosInstance';

const axiosInstance = Axios();

const userModelsManager = {
  getUserModels(url: any) {
    return axiosInstance.v2({
      url: url,
      method: 'GET'
    });
  }
};

export default userModelsManager;
